// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__0Xwl9","brilho":"Skeleton_brilho__cvuh+","texto":"Skeleton_texto__lEs6f","bloco":"Skeleton_bloco__imjiP","circulo":"Skeleton_circulo__zusMN"};